var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label && _vm.hex)?_c('span',{class:['tag', { readonly: _vm.readonly }],style:(("background-color: " + _vm.hex + "; color: " + _vm.textHex))},[(!_vm.readonly)?_c('i',{staticClass:"fas fa-times close",on:{"click":_vm.close}}):_vm._e(),_vm._v(" "),_c('span',{on:{"click":_vm.action}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e600b07","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tag.vue
// module id = null
// module chunks = 